import React, { useState } from 'react';
import {
  Box,
  Typography,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  TableContainer,
  Paper,
  TextField,
  Button,
  Divider,
  InputAdornment,
  Card,
  CardContent,
} from '@mui/material';
import Swal from 'sweetalert2';
import { useNavigate, useLocation } from 'react-router-dom';
import { postRequest } from '../../../lib/api'; // Adjust this path as needed

const VAT_RATE = 0.2;

const Wills = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { product_id, branch_id } = location.state || {};

  const singleRows = [
    { type: 'Low', points: 'Up to 30' },
    { type: 'Medium', points: '31 - 80' },
    { type: 'High', points: 'Above 81' },
  ];

  const mirrorRows = [
    { type: 'Low', points: 'Up to 30' },
    { type: 'Medium', points: '31 - 80' },
    { type: 'High', points: 'Above 81' },
  ];

  const codicilRow = [{ type: 'Any', points: 'N/A' }];

  const [singleCosts, setSingleCosts] = useState(singleRows.map(() => ({ mlmLegalCost: '', vat: 0, total: 0 })));
  const [mirrorCosts, setMirrorCosts] = useState(mirrorRows.map(() => ({ mlmLegalCost: '', vat: 0, total: 0 })));
  const [codicilCost, setCodicilCost] = useState({ mlmLegalCost: '', vat: 0, total: 0 });
   const [editId, seteditId] = useState(null);

  const handleChange = (index, value, section) => {
    const cost = parseFloat(value) || 0;
    const vat = +(cost * VAT_RATE).toFixed(2);
    const total = +(cost + vat).toFixed(2);

    if (section === 'single') {
      const updated = [...singleCosts];
      updated[index] = { mlmLegalCost: value, vat, total };
      setSingleCosts(updated);
    } else if (section === 'mirror') {
      const updated = [...mirrorCosts];
      updated[index] = { mlmLegalCost: value, vat, total };
      setMirrorCosts(updated);
    } else if (section === 'codicil') {
      setCodicilCost({ mlmLegalCost: value, vat, total });
    }
  };

  const renderTable = (title, rows, costs, sectionKey) => (
    <Box mb={4}>
      <Typography variant="h6" fontWeight="500" mt={3} mb={1}>
        {title}
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f4f4f4' }}>
              <TableCell><strong>Type</strong></TableCell>
              <TableCell><strong>No of Points</strong></TableCell>
              <TableCell><strong>MLM Legal Cost</strong></TableCell>
              <TableCell><strong>VAT</strong></TableCell>
              <TableCell><strong>Total Cost</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {rows.map((row, idx) => (
              <TableRow key={idx}>
                <TableCell>{row.type}</TableCell>
                <TableCell>{row.points}</TableCell>
                <TableCell>
                  <TextField
                    size="small"
                    placeholder="£"
                    value={costs[idx].mlmLegalCost}
                    fullWidth
                    onChange={(e) => handleChange(idx, e.target.value, sectionKey)}
                  />
                </TableCell>
                <TableCell>£{costs[idx].vat.toFixed(2)}</TableCell>
                <TableCell>£{costs[idx].total.toFixed(2)}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );

  const renderCodicilTable = () => (
    <Box mb={4}>
      <Typography variant="h6" fontWeight="500" mt={3} mb={1}>
        Codicil
      </Typography>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow sx={{ backgroundColor: '#f4f4f4' }}>
              <TableCell><strong>Type</strong></TableCell>
              <TableCell><strong>No of Points</strong></TableCell>
              <TableCell><strong>MLM Legal Cost</strong></TableCell>
              <TableCell><strong>VAT</strong></TableCell>
              <TableCell><strong>Total Cost</strong></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            <TableRow>
              <TableCell>{codicilRow[0].type}</TableCell>
              <TableCell>{codicilRow[0].points}</TableCell>
              <TableCell>
                <TextField
                  size="small"
                  placeholder="£"
                  value={codicilCost.mlmLegalCost}
                  fullWidth
                  onChange={(e) => handleChange(0, e.target.value, 'codicil')}
                />
              </TableCell>
              <TableCell>£{codicilCost.vat.toFixed(2)}</TableCell>
              <TableCell>£{codicilCost.total.toFixed(2)}</TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );

  const handleSubmit = async () => {
    if (!product_id || !branch_id) {
      Swal.fire('Error', 'Missing product or branch information.', 'error');
      return;
    }

    const singleWill = singleRows.map((row, idx) => ({
      complexity: row.type,
      pointsRange: row.points,
      mlmLegalCost: parseFloat(singleCosts[idx].mlmLegalCost) || 0,
      vat: singleCosts[idx].vat,
      totalCost: singleCosts[idx].total,
    }));

    const mirrorWill = mirrorRows.map((row, idx) => ({
      complexity: row.type,
      pointsRange: row.points,
      mlmLegalCost: parseFloat(mirrorCosts[idx].mlmLegalCost) || 0,
      vat: mirrorCosts[idx].vat,
      totalCost: mirrorCosts[idx].total,
    }));

    const codicil = {
      complexity: codicilRow[0].type,
      pointsRange: codicilRow[0].points,
      mlmLegalCost: parseFloat(codicilCost.mlmLegalCost) || 0,
      vat: codicilCost.vat,
      totalCost: codicilCost.total,
    };

    try {

          const payload = {
      product_id,
        branch_id,
        singleWill,
        mirrorWill,
        codicil,
    };

     let res;
        console.log(editId , 'editId@123')
        if (editId) {
          res = await postRequest(`private/editWillCost/${editId}`, payload);
        } else {
          res = await postRequest(`private/createWillCost`, payload);
        }
      

      if (res?.status === 200) {
        Swal.fire('Success', res.message || 'Will cost saved!', 'success');
        navigate(-1);
      } else {
        Swal.fire('Error', res?.message || 'Failed to save will cost.', 'error');
      }
    } catch (err) {
      Swal.fire('Error', 'Something went wrong!', 'error');
    }
  };

React.useEffect(() => {
  const fetchExistingLpaCosts = async () => {
    try {
      const res = await postRequest(
        `private/getWillCost`,
        { branch_id, product_id }
      );

      if (res?.data) {
        seteditId(res?.data?._id);

        const singleData = res?.data?.singleWill || [];
        const mirrorData = res?.data?.mirrorWill || [];
        const codicilData = res?.data?.codicil || null;

        const format = (item) => ({
          mlmLegalCost: item?.mlmLegalCost?.toString() || '',
          vat: item?.vat || 0,
          total: item?.totalCost || 0,
        });

        console.log(codicilData[0].mlmLegalCost, 'codicilData@12345')

        // Ensure mapping aligns with your original 3 entries
        setSingleCosts(singleRows.map((_, i) => format(singleData[i] || {})));
        setMirrorCosts(mirrorRows.map((_, i) => format(mirrorData[i] || {})));
        setCodicilCost(format(codicilData[0] || {}));

      }
    } catch (error) {
      console.error('Failed to fetch Will cost data', error);
    //  Swal.fire('Error', 'Failed to fetch existing will cost data.', 'error');
    }
  };

  if (branch_id && product_id) fetchExistingLpaCosts();
}, [branch_id, product_id]);


  return (
    <Box p={4}>
      <Typography variant="h5" fontWeight={600} mb={2}>
        Manage Wills
      </Typography>

      <Divider sx={{ mb: 2 }} />

      {renderTable('Single Will', singleRows, singleCosts, 'single')}
      {renderTable('Mirror Will', mirrorRows, mirrorCosts, 'mirror')}
      {renderCodicilTable()}

      <Box mt={2} display="flex" gap={2}>
        <Button variant="outlined" onClick={() => navigate(-1)}>
          Cancel
        </Button>
        <Button variant="contained" className='red-bg red-button text-capitalize' onClick={handleSubmit}>
          Submit
        </Button>
      </Box>
    </Box>
  );
};

export default Wills;
